import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

export const findFileTypes = createAsyncThunk(
  "fileTypes/findFileTypes",
  async (arg, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const fileTypesList = state.fileTypes?.fileTypesList;
    let maxUpdate: number = 0;

    if (fileTypesList.length > 0) {
      const orderedList = [...fileTypesList].sort((a, b) => {
        if (a.updatedAt && b.updatedAt && a.updatedAt < b.updatedAt) {
          return -1;
        }
        if (a.updatedAt && b.updatedAt && a.updatedAt > b.updatedAt) {
          return 1;
        }
        return 0;
      });
      maxUpdate = orderedList[orderedList.length - 1].updatedAt!;
    }

    try {
      const params = {
        limit: 50000,
        where: {
          module: "document",
          updatedAt: { ">": maxUpdate },
          // sourceOrganization: state.userAuthentication.user?.sourceOrganization,
        },
      };
      const { data } = await axiosInstance.get(`${api.baseURL}category`, { params });
      let newList = [...fileTypesList];

      data.forEach((element: any) => {
        if (newList.find((el) => el.id === element.id)) {
          let category = newList.find((el) => el.id === element.id);
          const indexToUpdate = newList.indexOf(category!);
          newList.splice(indexToUpdate, 1);
          newList.push(element);
        } else {
          newList.push(element);
        }
      });

      return newList;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
